<section id="select-action">
  <ul class="action-list">
    <li class="action-list-item enrich-lite">
      <div class="enrich-header">
        <h3>Enrichment</h3>
        @if (creditBalance) {
          <div class="credit-pill"
               [class.credit-pill--warning]="creditsExhausted"
               [matTooltip]="creditTooltip"
               matTooltipPosition="above"
               [matTooltipShowDelay]="500">
            <img [src]="creditIcon" alt="" class="credit-pill__icon">
            <span>{{ creditsRemaining | compactNumberValues }} remaining</span>
          </div>
        } @else {
          <app-skeleton [style]="'credit-pill'" class="credit-pill-skeleton"></app-skeleton>
        }
      </div>
      @if (enrichmentMappingsConfigured === false) {
        <div class="message info kyloe-message">
          <i class="material-icons-outlined notranslate">info</i>
          <span>Enrichment field mappings are not configured. Validation Score and Enrichment Data Record ID must be mapped before this rule can be saved.
            <br>Set this up now, in
            <a routerLink="/enrichmentSettings" target="_blank"
               matTooltip="Open Enrichment Settings in a new tab" matTooltipShowDelay="500">Enrichment Settings
              <i class="material-icons-outlined notranslate" aria-hidden="true">open_in_new</i>
            </a>
          </span>
        </div>
      }
      @if (!liteControl.value && creditsExhausted) {
        <div class="message warning kyloe-message">
          <i class="material-icons-outlined notranslate">info</i>
          <span>{{ creditsExhaustedMessage }}</span>
        </div>
      }
      <mat-button-toggle-group class="kyloe-rule-toggle" [formControl]="liteControl" hideSingleSelectionIndicator="true" aria-label="Enrichment mode"
                               [disabled]="enrichmentMappingsConfigured === false"
                               (change)="liteControl.markAsDirty()">
        <mat-button-toggle [value]="true">Validate</mat-button-toggle>
        <mat-button-toggle [value]="false" [disabled]="creditsExhausted"
                           [matTooltip]="creditsExhausted ? creditsExhaustedMessage : ''"
                           [matTooltipShowDelay]="500"
                           matTooltipPosition="above">Enrich</mat-button-toggle>
      </mat-button-toggle-group>
      <aside>
        <div class="message tip tip--compare kyloe-message">
          <i class="material-icons-outlined notranslate">info</i>
          <span class="tip-compare__body">
            <span class="tip-compare__row" [class.tip-compare__row--active]="liteControl.value">
              <strong>Validation Score:</strong> Assess the record's Personal Email (email) and Home Phone (phone) and returns a validation score only (1 = best, 5 = worst)
            </span>
            <span class="tip-compare__row" [class.tip-compare__row--active]="!liteControl.value">
              <strong>Enrich:</strong> Returns a validation score and updates the record with additional information from the Enrichment data, as specified in
              <a routerLink="/enrichmentSettings" target="_blank"
                 matTooltip="Open Enrichment Settings in a new tab" matTooltipShowDelay="500">Enrichment settings
                <i class="material-icons-outlined notranslate" aria-hidden="true">open_in_new</i>
              </a>
            </span>
          </span>
        </div>
      </aside>
    </li>
  </ul>
</section>
